import React, { useState, useEffect ,useMemo} from "react";
import { ProductService } from "../services/ProductService.js";
import './ProduitsPicker.css';

// reçoit existingProductIds en prop
export default function ProduitsPicker({ onClose, onSelect, existingProductIds = [] }) {

  const productService = useMemo(() => new ProductService(), []);

  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

 
  const [searching, setSearching] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");

    // 🟢 Chargement initial de tous les produits
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const data = await productService.getAllProducts();
        setProducts(data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [productService]); // 🟢 3. Ajouté dans le tableau de dépendances

  // 🟢 Recherche avec debounce (400ms après la dernière frappe)
  useEffect(() => {
    const delayDebounce = setTimeout(async () => {
      if (searchQuery.trim().length >= 2) {
        setSearching(true);
        try {
          const data = await productService.searchProducts(searchQuery);
          setProducts(data || []);
        } catch (err) {
          setError("Erreur lors de la recherche : " + err.message);
          setProducts([]);
        } finally {
          setSearching(false);
        }
      } else if (searchQuery.trim().length === 0) {
        // Si on efface la recherche, recharge tous les produits
        try {
          const data = await productService.getAllProducts();
          setProducts(data || []);
        } catch (err) {
          console.error(err);
        }
      }
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery, productService]); 


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const service = new ProductService();
        const data = await service.getAllProducts();
        setProducts(data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const handleToggle = (product) => {
    //  BLOCAGE : Empêcher de sélectionner un produit déjà dans le BCC
    if (existingProductIds.includes(product.id)) {
      return;
    }

    setSelectedProducts(prev => {
      const isSelected = prev.find(p => p.id === product.id);
      if (isSelected) {
        return prev.filter(p => p.id !== product.id);
      } else {
        return [...prev, product];
      }
    });
  };

  const handleConfirm = () => {
    onSelect(selectedProducts);
    onClose();
  };

  if (loading) return <div className="picker-overlay"><div className="picker-container"><p>Chargement...</p></div></div>;
  if (error) return <div className="picker-overlay"><div className="picker-container"><p style={{color:'red'}}>Erreur : {error}</p></div></div>;

  return (
    <div className="picker-overlay">
      <div className="picker-container" style={{ maxWidth: '900px' }}>
        <h2 className="picker-title">Sélectionner des produits pour le Bon de Commande</h2>
        
         <div style={{ marginBottom: '15px', position: 'relative' }}>
          <input
            type="text"
            placeholder="🔍 Rechercher (Réf, Désignation, Catégorie, Code HS...) - Min. 2 caractères"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              width: '100%',
              padding: '12px',
              paddingRight: searching ? '40px' : '12px',
              fontSize: '14px',
              border: '1px solid #ccc',
              borderRadius: '6px',
              outline: 'none',
              boxSizing: 'border-box'
            }}
          />
          {searching && (
            <div style={{
              position: 'absolute',
              right: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '14px',
              color: '#666'
            }}>
              ⏳
            </div>
          )}
        </div>

        <div className="picker-table-wrapper">
          <table className="picker-table">
            <thead>
              <tr>
                <th style={{ width: '40px' }}></th>
                <th>ID</th>
                <th>Référence</th>
                <th>Ref. Fabricant</th>
                <th>Désignation</th>
              </tr>
            </thead>
            <tbody>
              {products.length === 0 ? (
                <tr><td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>Aucun produit disponible.</td></tr>
              ) : (
                products.map((p) => {
                  const isAlreadyInBCC = existingProductIds.includes(p.id); //  Déjà dans le BCC
                  const isSelected = selectedProducts.find(sp => sp.id === p.id);
                  
                  return (
                    <tr 
                      key={p.id} 
                      className={`picker-row ${isSelected ? "selected" : ""} ${isAlreadyInBCC ? "already-added" : ""}`}
                      onClick={() => !isAlreadyInBCC && handleToggle(p)}
                      style={{ 
                        cursor: isAlreadyInBCC ? 'not-allowed' : 'pointer',
                        opacity: isAlreadyInBCC ? 0.5 : 1,
                        backgroundColor: isAlreadyInBCC ? '#f5f5f5' : undefined
                      }}
                    >
                      <td onClick={(e) => e.stopPropagation()}>
                        <input 
                          type="checkbox" 
                          checked={!!isSelected} 
                          disabled={isAlreadyInBCC} //  Case désactivée si déjà dans le BCC
                          onChange={() => handleToggle(p)} 
                        />
                      </td>
                      <td>{p.id}</td>
                      <td>{p.reference || p.refInterne || 'N/A'}</td>
                      <td>{p.refFabricant || p.ean || 'N/A'}</td>
                      <td>
                        {p.designation || p.name || 'N/A'}
                        {isAlreadyInBCC && <span style={{ color: '#e74c3c', marginLeft: '10px', fontWeight: 'bold' }}>⚠️ Déjà dans le bon</span>}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        <div className="picker-actions">
          <button className="picker-btn" onClick={handleConfirm} disabled={selectedProducts.length === 0}>
            Ajouter {selectedProducts.length > 0 ? `(${selectedProducts.length})` : ''}
          </button>
          <button className="picker-btn-secondary" onClick={onClose}>Annuler</button>
        </div>
      </div>
    </div>
  );
}